import { useQuery } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";
import { KlydoRatingStats } from "../../../api/klydo";

/** Average rating + vote count for a single klydo (klydo modal). */
export const useKlydoRatingStats = (klydoId: string, enabled?: boolean) => {
  return useQuery<KlydoRatingStats>({
    queryKey: ["klydoRatingStats", klydoId],
    queryFn: () => klydoApiClient.getKlydoRatingStats(klydoId),
    enabled: enabled ?? !!klydoId,
  });
};

/**
 * Average rating + vote count for a list of klydos (klydos table). Returns a
 * map keyed by klydoId for easy per-row lookup.
 */
export const useKlydoRatingStatsBatch = (klydoIds: string[]) => {
  return useQuery<Record<string, KlydoRatingStats>>({
    queryKey: ["klydoRatingStatsBatch", [...klydoIds].sort()],
    queryFn: async () => {
      const stats = await klydoApiClient.getKlydoRatingStatsBatch(klydoIds);
      return Object.fromEntries(stats.map((s) => [s.klydoId, s]));
    },
    enabled: klydoIds.length > 0,
  });
};
